import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import sv from './lang.ts'


Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    locales: { sv },
    current: 'sv'
  }
})
